// Generated by purs version 0.15.16
var callCC = function (dict) {
    return dict.callCC;
};
export {
    callCC
};
//# sourceMappingURL=index.js.map
